export default __webpack_public_path__ + "static/media/logo.a141d2df.svg";